import IventoryCard from "../../../common/helpers/inventory-card";
import { useNavigate } from "react-router-dom";
import Permission from "../../../common/components/auth/Permission";
import { PiFiles } from "react-icons/pi";
import { FaMoneyBill } from "react-icons/fa";
import { MdQuestionMark } from "react-icons/md";
import { LuShoppingCart } from "react-icons/lu";
import { FaRegUser } from "react-icons/fa";
import { FiGitPullRequest } from "react-icons/fi";
import { GiReturnArrow } from "react-icons/gi";
import { GrServices } from "react-icons/gr";
import { FaFileInvoice } from "react-icons/fa6";

const PurchaseDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="relative w-full h-full overflow-y-auto bg-white text-black dark:text-black">
      <section className="w-full p-6">
        <header className="w-full pb-4 mb-6 border-b border-gray-200">
          <h2 className="text-3xl font-bold text-gray-800 tracking-tight">
            🛒 Módulo de Compras
          </h2>
        </header>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
          <Permission permission="view:inventory-categories">
            <div
              onClick={() => navigate("/compras/categorias")}
              className="cursor-pointer"
            >
              <IventoryCard
                icon={<PiFiles />}
                iconSize="70px"
                title="Categorias"
                iconClassName="text-locavibe"
              />
            </div>
          </Permission>

          <Permission permission="view:inventory-suppliers">
            <div
              onClick={() => navigate("/compras/ordem")}
              className="cursor-pointer"
            >
              <IventoryCard
                icon={<LuShoppingCart />}
                iconSize="70px"
                title="Ordem de Compras"
                iconClassName="text-locavibe"
              />
            </div>
          </Permission>
          <Permission permission="view:inventory-workorder">
            <div
              onClick={() => navigate("/compras/solicitante")}
              className="cursor-pointer"
            >
              <IventoryCard
                icon={<FaRegUser />}
                iconSize="70px"
                title="Solicitantes"
                iconClassName="text-locavibe"
              />
            </div>
          </Permission>
          <Permission permission="view:inventory-workorder">
            <div
              onClick={() => navigate("/compras/centroDeCustos")}
              className="cursor-pointer"
            >
              <IventoryCard
                icon={<FaMoneyBill />}
                iconSize="70px"
                title="Centro de Custos"
                iconClassName="text-locavibe"
              />
            </div>
          </Permission>

          <Permission permission="view:inventory-workorder">
            <div
              onClick={() => navigate("/compras/sugestaoDeCompra")}
              className="cursor-pointer"
            >
              <IventoryCard
                icon={<MdQuestionMark />}
                iconSize="70px"
                title="Sugestão de Compra"
                iconClassName="text-locavibe"
              />
            </div>
          </Permission>

          <Permission permission="view:inventory-workorder">
            <div
              onClick={() => navigate("/compras/servicosExternos")}
              className="cursor-pointer"
            >
              <IventoryCard
                icon={<GrServices />}
                iconSize="70px"
                title="Serviços externos"
                iconClassName="text-locavibe"
              />
            </div>
          </Permission>

          <Permission permission="view:inventory-workorder">
            <div
              onClick={() => navigate("/compras/requestordem")}
              className="cursor-pointer"
            >
              <IventoryCard
                icon={<FiGitPullRequest />}
                iconSize="70px"
                title="Requisições de compras"
                iconClassName="text-locavibe"
              />
            </div>
          </Permission>

          <Permission permission="view:inventory-workorder">
            <div
              onClick={() => navigate("/compras/devolucao")}
              className="cursor-pointer"
            >
              <IventoryCard
                icon={<GiReturnArrow />}
                iconSize="70px"
                title="Devoluções de compra"
                iconClassName="text-locavibe"
              />
            </div>
          </Permission>
          <Permission permission="view:inventory-workorder">
            <div
              onClick={() => navigate("/compras/NFSEntry")}
              className="cursor-pointer"
            >
              <IventoryCard
                icon={<FaFileInvoice />}
                iconSize="70px"
                title="Notas fiscais de Entrada"
                iconClassName="text-locavibe"
              />
            </div>
          </Permission>
        </div>
      </section>
    </div>
  );
};

export default PurchaseDashboard;
